import * as React from 'react';
import {FormInput, TextField, DropdownField} from "../static/Inputs";
import {Button} from "../static/Elements";
import { withAlert } from 'react-alert'

class CreateTitle extends React.Component {

  /* ---------- lifecycle methods ----------*/
  constructor(props) {
    super(props);
    this.state = {
      title: {
        title: ``,
        category: `Miscellaneous`,
        exclude: false,
      },
      validationErrors: false,
    }
  }

  /* ---------- event handlers ----------*/

  clearState = () => this.setState({
    title: {
      title: ``,
      category: ``,
      exclude: false,
    },
    errors: [],
  });

  onCancel = () => {
    this.clearState();
    this.props.closeModal();
  };

  onInputChange = (field) => (input) => {
    console.log(field, input);

    if (input === "true" || input === "false") {
        input = JSON.parse(input);
    }

    console.log(this.state.title);
    console.log(`type of input: ${typeof input}`);
    this.setState({
      title: {
        ...this.state.title,
        [field]: input
      }
    });
    console.log(this.state.title);
  };

  // onTypeChange = ()

  onSubmitCreateTitle = (config) => () => {
    console.log(config);
    const { createTitle, closeModal, alert, titles } = this.props;

    let duplicate = false;
    if (this.state.title.exclude === false) {
      for (let title of titles.includes) {
        if (title.title === config.title) {
          duplicate = true;
          break;
        }
      }
    }
    if (this.state.title.exclude === true) {
      for (let title of titles.excludes) {
        if (title.title === config.title) {
          duplicate = true;
          break;
        }
      }
    }
    // console.log('EXCLUDE IS ${}')
    if (duplicate) {
      closeModal();
      alert.info(<p className={`alert-message`}>Title '{config.title}' already exists</p>)
    } else {
      // console.log(`Adding '${config.title}' to titles list (exclude: ${config.exclude})`);
      console.log(`Exclude type ${typeof config.exclude}`);
      createTitle(config);
      closeModal();
      alert.success(<p className={`alert-message`}>Successfully added '{config.title}' under {config.category}</p>)
    }
  };

  /* ---------- render ----------*/

  render () {

    const {
      title,
    } = this.state;

    const {
      categories,
      closeModal,
    } = this.props;

    const {
      onInputChange,
      onSubmitCreateTitle,
    } = this;

    const fieldConfigs = {
      title: {
        value: title.title,
        name: `create-job-title`,
        label: `Job Title`,
        onChange: onInputChange(`title`),
        placeholder: `Enter job title...`,

      },
      category: {
        value: title.category,
        name: `select-title-category`,
        label: `Category`,
        onChange: onInputChange(`category`),
        selected: `Choose...`,
      }
    };

    const titleTypeConfig = {
      value: title.exclude,
      name: `sort-input`,
      label: `Title Type`,
      className: `margin-right`,
      onChange: onInputChange(`exclude`)
    };

    const canSubmit = (!!title.title && title.title !== ``);

    return (
        <div className={`create-lead`}>
          <FormInput>
            <TextField {...fieldConfigs.title}/>
            <div className={'split-line-field'}>
              <DropdownField {...fieldConfigs.category}>
                {
                  categories.map((category) => (
                      <option className={"dropdown-item"} key={category} value={category}>{category}</option>
                  ))
                }
              </DropdownField>

              <DropdownField {...titleTypeConfig}>
                <option value={false}>Include</option>
                <option value={true}>Exclude</option>
              </DropdownField>
            </div>
          </FormInput>
          <footer>
            <Button onClick={closeModal}
                    type="theme-light">
              Cancel
            </Button>
            <Button
                    onClick={onSubmitCreateTitle(title)}
                    disabled={!canSubmit}>
              Create
            </Button>
          </footer>
        </div>
    )
  }

}

export default withAlert(CreateTitle);


// WEBPACK FOOTER //
// ./src/components/Titles/CreateTitle.js